import { combineReducers } from '@reduxjs/toolkit';

import { appReducer } from 'src/stores/app';

import { reducer as authReducer } from './screens/auth/auth.reducer';
import { reducer as userReducer } from './screens/user/user.reducer';
import { reducer as caseStudyReducer } from './screens/caseStudy/caseStudy.reducer';
import { reducer as categoryReducer } from './screens/category/category.reducer';
import { reducer as commonReducer } from './screens/common/common.reducer';
import { reducer as pageReducer } from './screens/page/page.reducer';
import { reducer as pageSessionReducer } from './screens/pageSession/pageSession.reducer';
import { reducer as pageContentReducer } from './screens/pageContent/pageContent.reducer';
import { reducer as mailReducer } from './screens/mail/mail.reducer';

export const reducer = combineReducers({
  app: appReducer,

  auth: authReducer,
  user: userReducer,
  caseStudy: caseStudyReducer,
  category: categoryReducer,
  common: commonReducer,
  page: pageReducer,
  pageSession: pageSessionReducer,
  pageContent: pageContentReducer,
  mail: mailReducer,
})
